var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('canvas',{style:(`position: absolute; left: -9999px; top: -9999px;`),attrs:{"id":_vm.cid,"canvas-id":_vm.cid,"width":_vm.size * 2,"height":_vm.size * 2}}),_vm._v(" "),(_vm.qrCodeSrc)?_c('img',{style:(`width: ${_vm.size}px; height: ${_vm.size}px;`),attrs:{"src":_vm.qrCodeSrc,"mode":"aspectFit"}}):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }